import React from "react";
// import ViewRendering from "../../../components/ViewRendering";
import { renderingStuff, images } from "../utils";
import NewViewRendering from "../components/ViewRendering/NewViewRendering";
import DashboardLayout from "../components/HOC/DashboardLayout";

function OnlineResourceStaffDashboard(props) {
  return (
    <div>
		<DashboardLayout name="Online Resource Dashboard" image={images.imgAcademicOnlineResource}>
			<NewViewRendering {...props} data={renderingStuff.OnlineResourceLinks_Staff} />
		</DashboardLayout>
    </div>
  );
}

export default OnlineResourceStaffDashboard;